function login({ provider, autoClose = false, redirectTo = null, isExtensionOnboarding = false }) {
  const close = autoClose ? 'close=1&' : '';
  let url = `/oauth/${provider}/authorize?${close}`;

  url += redirectTo ? `&redirectTo=${encodeURIComponent(redirectTo)}` : '';
  url += isExtensionOnboarding ? '&isExtensionOnboarding=1' : '';

  window.location.href = url;
}

const OAuth2 = {
  login,
};

export default OAuth2;
